<template>
  <Tags
    :tags="tags"
    :rows="rows"
  />
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import Tags from './Tags.vue';

  type Attributes = {
    category: string;
    rows: string;
    subcategories: {
      slug: string;
      name: string;
    }[];
  };

  export default defineNuxtComponent({
    name: 'TagsBlock',
    components: { Tags },

    props: {
      elem: {
        type: Object as PropType<TContent<Attributes>>,
        required: true,
      },
    },

    computed: {
      tags(): Array<{ name: string; url: string }> {
        return this.elem.attributes.subcategories.map((subcategory) => {
          return {
            id: subcategory.slug,
            name: subcategory.name,
            url: `/health/${this.elem.attributes.category}/${subcategory.slug}/`,
          };
        });
      },

      rows(): number {
        return Number(this.elem.attributes.rows) || 2;
      },
    },
  });
</script>
